export default "__VITE_ASSET__C084hpW1__"